var map = {
	"./feature_buy_en.png": "2439",
	"./feature_buy_id.png": "b293",
	"./feature_buy_ph.png": "f9e34",
	"./feature_buy_th.png": "5cd3",
	"./feature_buy_zh.png": "f74f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aaab";